import TitleBarSpacer from "../../../components/layout/title_bar/TitleBarSpacer";
import TitleBarTitle from "../../../components/layout/title_bar/TitleBarTitle";
import TitleBar from "../../../components/layout/title_bar/TitleBar";
import { WalletContext } from "../../../contexts/WalletContext";
import Panel from "../../../components/layout/panel/Panel";
import { Button, Spinner } from "react-bootstrap";
import { useContext } from "react";

const TokenGallery = () => {

    const { artContract, address } = useContext(WalletContext);
    console.log(artContract);

    const fetchGame = async () => {
        if(artContract) {
            console.log("what");
            try {
                const res = await artContract.getTokensOf(address);
                console.log(res[0]);
            } catch(err) {
                console.log(err);
            }
        }
    }


    return (
        <Panel>
            {false && 
                <div className="bg-black d-flex justify-content-center align-items-center container">
                    <Spinner animation="border" role="status" aria-describedby="loading" />
                </div>
            }
            {false && <></>}
            {true &&
                <>
                    <TitleBar className="bg-dark my-2 py-2 rounded">
                        <TitleBarSpacer width={3} />
                        <TitleBarTitle>Your NFTs</TitleBarTitle>
                    </TitleBar>
                    <Button variant="warning" onClick={() => fetchGame()} >Click</Button>
                </>
            }
        </Panel>
    );
}


export default TokenGallery;